import "./Home.scss";
import Navbar from "../../Components/Navbar/Navbar";
import Footer from "../../Components/Footer/Footer";
import Slogan from "../../Components/Slogan/Slogan";
import Accordion from "react-bootstrap/Accordion";

//Images
import artwork1 from "../../Assets/Images/artwork1.png";
import artwork2 from "../../Assets/Images/artwork2.png";
import artwork3 from "../../Assets/Images/artwork3.png";
import artwork4 from "../../Assets/Images/artwork4.png";
import axelNfts from "../../Assets/Images/axels.png";
import map from "../../Assets/Images/map.png";
import prtckNft from "../../Assets/Images/ptrckNft.png";
import matryxNft from "../../Assets/Images/matryxNft.png";
import arkhamNft from "../../Assets/Images/arkhamNft.png";
import prtckText from "../../Assets/Images/ptrckText.png";
import matryxText from "../../Assets/Images/matryxText.png";
import arkhamText from "../../Assets/Images/arkhamText.png";
import faqArt1 from "../../Assets/Images/faqArtwork1.png";
import faqArt2 from "../../Assets/Images/faqArtwork2.png";
import faqArt3 from "../../Assets/Images/faqArtwork3.png";
import faqArt4 from "../../Assets/Images/faqArtwork4.png";

function Landing() {
  return (
    <div id="landing">
      <img className="artwork2" src={artwork2} alt="artwork" />
      <img className="artwork1" src={artwork1} alt="artwork" />
      <img className="artwork3" src={artwork3} alt="artwork" />
      <Navbar homeNav="navbar navbar-expand-md  bg-custom" />
      <h1 className="landingText">AXEL</h1>
      <a href="/" className="mintBtn">
        <div className="mintBox">Mint Your Axel</div>
      </a>
    </div>
  );
}

function Axels() {
  return (
    <div id="axels">
      <Slogan />
      <div className="axelContent">
        <h1>Some Axels</h1>
        <h3>These are all hand-draw NFT artworks, enjoy I guess</h3>
        <img className="axelDisplay" src={axelNfts} alt="axels" />
      </div>
      <Slogan />
    </div>
  );
}

function Vision() {
  return (
    <div id="vision">
      <div className="visionContent">
        <div class="imageContainer">
          <img className="artwork4" src={artwork4} alt="artwork" />
        </div>
        <div className="visionText">
          <h1>AXEL VISION</h1>
          <h3>These are all hand-draw NFT artworks, enjoy I guess</h3>
          <h4 className="visionParagraph">
            Axel is bigger than just an NFT, we’re a movement. A movement of
            people that want to make a sh*t ton crypto in the web3 space. The
            goal, I guess, is to build a large and strong community of people
            that want to earn in all different ways. Web3 is going to change the
            interent compeletly, and it already has. Why not hop on this before
            it blows up entirely. Our team has made a base outline of what we
            are going to accomplish but we want to find more ways, as there are
            always some randoming f*cking web3 assests out there that can earn
            you a bunch of crypto. Another goal is to build a bunch of new
            projects, projects that will benefit the web3 mfs. Our team has some
            crazy sh*t in mind, and imagine some of the dope a** people we can
            meet throughout the Axel journey. But we ain’t trying to spoiling
            our whole roadmap yet, cause we have some crazy things in store. We
            are still learning and trying a ton of sh*t so why not just join the
            discord, we’re giving away crypto to you f*cks.
          </h4>
        </div>
      </div>
    </div>
  );
}

function Roadmap() {
  return (
    <div id="roadmap">
      <div className="roadmapContent">
        <h1>Roadmap</h1>
        <h3>
          This sh*t was draw up in like two minutes, so you better appreciate it{" "}
        </h3>
        <img className="mapDisplay" src={map} alt="map" />
      </div>
    </div>
  );
}

function Team() {
  return (
    <div id="team">
      <div className="teamContent">
        <h1>Our Team</h1>
        <h3>Our owners aren’t famous, but we know what the f*ck we’re doing</h3>
        <div className="teamDisplay">
          <div className="teamProfile">
            <img className="nftDisplay" src={prtckNft} alt="nft" />
            <img className="textDisplay" src={prtckText} alt="nftText" />
            <p className="textHeader">Owner + Artist</p>
            <p className="textDescription">
              Bringing Axels to life. Experienced in business owning and all
              types of design.{" "}
            </p>
          </div>
          <div className="teamProfile">
            <img className="nftDisplay" src={matryxNft} alt="nft" />
            <img className="textDisplay" src={matryxText} alt="nftText" />
            <p className="textHeader">Project Manager</p>
            <p className="textDescription">
              {" "}
              Marketing operations and more. Ex-business owner. Experienced in
              side hustling, sneaker reselling, and flips
            </p>
          </div>
          <div className="teamProfile">
            <img className="nftDisplay" src={arkhamNft} alt="nft" />
            <img className="textDisplay" src={arkhamText} alt="nftText" />
            <p className="textHeader">Developer</p>
            <p className="textDescription">
              All developer work for Axel. Experienced business owner, sneaker
              reseller, and talented UI/UX designer
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

function Faq() {
  return (
    <div id="faq">
      <img id="artworkSize" className="faqArt1" src={faqArt1} alt="nft" />
      <img id="artworkSize" className="faqArt2" src={faqArt2} alt="nft" />
      <img id="artworkSize" className="faqArt3" src={faqArt3} alt="nft" />
      <img id="artworkSize" className="faqArt4" src={faqArt4} alt="nft" />
      <div className="faqContent">
        <h1>Faq</h1>
        <h3>Hope your question is here cause I can’t do anything if not</h3>
        <div className="faqAccordian">
          <Accordion>
            <Accordion.Item eventKey="0">
              <Accordion.Header>Can I cancel anytime?</Accordion.Header>
              <Accordion.Body>
                We make it extremely easy for you to cancel directly through
                your dashboard. Don’t like it? Give us some feedback (hyper link
                to feedback cancellation form) and let us know how we can
                improve. We hope to see you back again soon!
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="1">
              <Accordion.Header>Can I become a staff member?</Accordion.Header>
              <Accordion.Body>
                Yes of course, we are always looking to expand the team. Feel
                free to fill out this form to apply(hyper link to staff
                application). All positions are paid!
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="2">
              <Accordion.Header>
                I’m new to this, how can I get started?
              </Accordion.Header>
              <Accordion.Body>
                Glad to have you here, we have a very extensive guide on how to
                navigate our platform for anyone who is new along with a system
                that allows our staff to work 1-on-1. Our goal is to deliver
                service the right way.
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="3">
              <Accordion.Header>
                I had a horrible experience, who can I contact for help?
              </Accordion.Header>
              <Accordion.Body>
                Ouch we certainly don’t like to hear that, please report to us
                on the cancellation feedback form or get in contact directly
                with our team. We really hope to make your experience as
                pleasant as possible. Don’t hesitate to reach out, we take all
                concerns seriously.
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="4">
              <Accordion.Header>
                I had a horrible experience, who can I contact for help?
              </Accordion.Header>
              <Accordion.Body>
                Ouch we certainly don’t like to hear that, please report to us
                on the cancellation feedback form or get in contact directly
                with our team. We really hope to make your experience as
                pleasant as possible. Don’t hesitate to reach out, we take all
                concerns seriously.
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="5">
              <Accordion.Header>
                I had a horrible experience, who can I contact for help?
              </Accordion.Header>
              <Accordion.Body>
                Ouch we certainly don’t like to hear that, please report to us
                on the cancellation feedback form or get in contact directly
                with our team. We really hope to make your experience as
                pleasant as possible. Don’t hesitate to reach out, we take all
                concerns seriously.
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </div>
      </div>
    </div>
  );
}

function Home() {
  return (
    <div>
      <Landing />
      <Axels />
      <Vision />
      <Roadmap />
      <Team />
      <Faq />
      <Footer />
    </div>
  );
}

export default Home;
